import { classNamePrefix } from '../globals';

export function renderListService (services: HTMLDivElement[]) {
    const className = classNamePrefix + '-list-service';

    const listElement = document.createElement('ul');
    listElement.classList.add(className);

    services.forEach((service) => {
        const itemElement = document.createElement('li');
        itemElement.classList.add(className + '__item');
        itemElement.appendChild(service);

        listElement.appendChild(itemElement);
    });

    return listElement;
}